// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 152 ? "invite" : chunkId) + "." + {"152":"2c971b7b","721":"15dafd2e"}[chunkId] + ".css";
};